// test905
(905 && 0);
